<template>
  <div class="gallery-view-preview-wrapper">
    <v-img
      v-if="previewedGalleryMedia"
      aspect-ratio="1"
      width="100%"
      max-height="100%"
      :src="previewedGalleryMediaSrc"
      @click="openLightbox"
    ></v-img>
    <GalleryViewSkeletonLoader v-else />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType } from "vue"
import GalleryViewSkeletonLoader from "features/gallery/view/GalleryViewSkeletonLoader.vue"
import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import { IndexedGalleryMedium } from "features/gallery/gallery.types"
import { EventLightboxService } from "features/events/highlights/lightbox/event-lightbox.service"
import { PostLightboxService } from "features/posts/gallery/lightbox/post-lightbox.service"

export default defineComponent({
  name: "GalleryViewPreview",
  components: { GalleryViewSkeletonLoader },
  props: {
    previewedGalleryMedia: {
      type: Object as PropType<IndexedGalleryMedium>,
    },
  },
  setup(props) {
    const previewedGalleryMediaSrc = computed(() => {
      return props.previewedGalleryMedia?.uploaded_file?.preview?.url
    })
    const previewedGalleryMediaIndex = computed(() => {
      return props.previewedGalleryMedia?.index
    })

    const lightboxService: LightboxService | null = inject(
      "lightboxService",
      null
    )
    const eventLightboxService: EventLightboxService | null = inject(
      "EventLightboxService",
      null
    )
    const postLightboxService: PostLightboxService | null = inject(
      "PostLightboxService",
      null
    )
    const openLightbox = () => {
      if (postLightboxService) {
        postLightboxService.openLightbox(previewedGalleryMediaIndex.value)
        return
      }
      if (eventLightboxService) {
        eventLightboxService.openLightbox(previewedGalleryMediaIndex.value)
        return
      }
      if (lightboxService) {
        lightboxService.openLightbox(previewedGalleryMediaSrc.value)
      }
    }

    return {
      previewedGalleryMediaSrc,
      openLightbox,
    }
  },
})
</script>

<style scoped>
.gallery-view-preview-wrapper {
  flex-basis: 40%;
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.preview-loader ::v-deep .v-skeleton-loader__image {
  height: 100%;
}
</style>
